export default "__VITE_ASSET__cd864b87__"